module.exports = __webpack_public_path__ + "img/43_78.7b0ad2db.png";